import FloatToCursor from "./float-to-cursor";

class MainFirstScreen {
  private floatingBgContainer: HTMLElement | null = document.querySelector('.first-screen--main');
  constructor() {
    if(this.floatingBgContainer) {
      new FloatToCursor(this.floatingBgContainer, {
        initialXPercent: 70,
        initialYPercent: 60,
        minYPercent: 0,
        maxYPercent: 100,
        minXPercent: 50,
        maxXPercent: 100,
        debounceTimeout: 100
      });
    }
  }
}

export default function mainFirstScreen() {
  return new MainFirstScreen();
}